//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import InventoryCreateView from '@/views/Warehouse/WhInventory/create'
import InventoryListView from '@/views/Warehouse/WhInventory/list'
import InventoryTakeView from '@/views/Warehouse/WhInventory/take'
import InventoryUpdateView from '@/views/Warehouse/WhInventory/update'

//
export default {
    path: 'inventories',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'inventory-list',
            component: InventoryListView,
        },
        {
            path: 'create',
            name: 'inventory-create',
            component: InventoryCreateView,
            meta: {
                title: 'Crear inventario',
            },
        },
        {
            path: ':id',
            name: 'inventory-update',
            component: InventoryUpdateView,
            meta: {
                title: 'Datos de inventario',
            },
        },
        {
            path: 'take/:id',
            name: 'inventory-take',
            component: InventoryTakeView,
            meta: {
                title: 'Tomar inventario',
            },
        },
    ],
    meta: {
        title: 'Inventarios',
    },
}
